import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

interface IProps {
    title: string,
    subTitle: string,
    contactMessage: boolean
}
export default function HeaderWithTitle(props: IProps) {

    return (
        <header>
            <Row>
                <Col>
                    <Link to="/" className="text-pp-secondary font-weight-bolder ml-2">PHYSICIAN PORTAL</Link>
                    <br />

                    <h3 className="font-weight-bolder ml-2 mt-1 mb-4">{props.title}</h3>
                </Col>
                <Col hidden={!props.contactMessage} className="col-lg">
                    <h6 className="w100 pp-font-size-smallest text-right">Questions about the Physician Portal, certification requirements, or deadlines <br />should be addressed to <a className="underline" href="mailto:Questions@abpn.org">Questions@abpn.org</a> or contact (847) 229-6512.<br /><br />
                    Please allow 2 business days for a response to your message.</h6>
                </Col>
            </Row>
            {props.subTitle && 
            <h5 className=" mt-1 mb-4 ml-2">{props.subTitle}</h5>
            }
        </header>
    );
}
